import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'et',
  months: [
    'jaanuar',
    'veebruar',
    'märts',
    'aprill',
    'mai',
    'juuni',
    'juuli',
    'august',
    'september',
    'oktoober',
    'november',
    'detsember',
  ],
  monthsShort: ['jaan', 'veebr', 'märts', 'apr', 'mai', 'juuni', 'juuli', 'aug', 'sept', 'okt', 'nov', 'dets'],
  weekdays: ['pühapäev', 'esmaspäev', 'teisipäev', 'kolmapäev', 'neljapäev', 'reede', 'laupäev'],
  weekdaysMin: ['P', 'E', 'T', 'K', 'N', 'R', 'L'],
  weekdaysShort: ['pühap', 'esmasp', 'teisip', 'kolmap', 'neljap', 'reede', 'laup'],
  formats: {
    LT: 'H.mm',
    LTS: 'H.mm.ss',
    lt: 'H.mm',
    lts: 'H:mm:ss',
    L: 'DD.MM.YYYY',
    LL: 'D. MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D. MMMM',
    LLL: 'D. MMMM YYYY [kell] H.mm',
    'LLL-Y': 'D. MMMM HH.mm',
    LLLL: 'dddd D. MMMM YYYY [kell] H.mm',
    'LLLL-Y': 'dddd D. MMMM H.mm',
    l: 'DD.MM.YYYY',
    'l-Y': 'DD.MM',
    ll: 'D. MMM YYYY',
    'll-Y': 'D. MMM',
    'll-D': 'MMM YYYY',
    lll: 'D. MMM YYYY [kell] H.mm',
    'lll-Y': 'D. MMM H.mm',
    llll: 'ddd, D. MMMM YYYY [kell] H.mm',
    'llll-Y': 'ddd, D. MMM H.mm',
    'll-Y+w': 'ddd, D. MMM',
    'LT+to': 'H.mm ([GMT]Z)',
    'LLL+to': 'D. MMMM YYYY [kell] H.mm ([GMT]Z)',
  },
  meridiem: { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM' },
  past: {
    y: { one: '%s a tagasi', other: '%s a tagasi' },
    M: { one: '%s kuu tagasi', other: '%s kuu tagasi' },
    w: { one: '%s näd tagasi', other: '%s näd tagasi' },
    d: { one: '%s p tagasi', other: '%s p tagasi' },
    h: { one: '%s t tagasi', other: '%s t tagasi' },
    m: { one: '%s min tagasi', other: '%s min tagasi' },
    s: { one: '%s sek tagasi', other: '%s sek tagasi' },
  },
  future: {
    y: { one: '%s a pärast', other: '%s a pärast' },
    M: { one: '%s kuu pärast', other: '%s kuu pärast' },
    w: { one: '%s näd pärast', other: '%s näd pärast' },
    d: { one: '%s p pärast', other: '%s p pärast' },
    h: { one: '%s t pärast', other: '%s t pärast' },
    m: { one: '%s min pärast', other: '%s min pärast' },
    s: { one: '%s sek pärast', other: '%s sek pärast' },
  },
  pastLong: {
    y: { one: '%s aasta tagasi', other: '%s aasta tagasi' },
    M: { one: '%s kuu tagasi', other: '%s kuu tagasi' },
    w: { one: '%s nädala tagasi', other: '%s nädala tagasi' },
    d: { one: '%s päeva tagasi', other: '%s päeva tagasi' },
    h: { one: '%s tunni tagasi', other: '%s tunni tagasi' },
    m: { one: '%s minuti tagasi', other: '%s minuti tagasi' },
    s: { one: '%s sekundi tagasi', other: '%s sekundi tagasi' },
  },
  futureLong: {
    y: { one: '%s aasta pärast', other: '%s aasta pärast' },
    M: { one: '%s kuu pärast', other: '%s kuu pärast' },
    w: { one: '%s nädala pärast', other: '%s nädala pärast' },
    d: { one: '%s päeva pärast', other: '%s päeva pärast' },
    h: { one: '%s tunni pärast', other: '%s tunni pärast' },
    m: { one: '%s minuti pärast', other: '%s minuti pärast' },
    s: { one: '%s sekundi pärast', other: '%s sekundi pärast' },
  },
  abbr: {
    y: { one: '%s a', other: '%s a' },
    M: { one: '%s k', other: '%s k' },
    w: { one: '%s näd', other: '%s näd' },
    d: { one: '%s p', other: '%s p' },
    h: { one: '%s t', other: '%s t' },
    m: { one: '%s min', other: '%s min' },
    s: { one: '%s s', other: '%s s' },
  },
  full: {
    y: { one: '%s aasta', other: '%s aastat' },
    M: { one: '%s kuu', other: '%s kuud' },
    w: { one: '%s nädal', other: '%s nädalat' },
    d: { one: '%s päev', other: '%s päeva' },
    h: { one: '%s tund', other: '%s tundi' },
    m: { one: '%s minut', other: '%s minutit' },
    s: { one: '%s sekund', other: '%s sekundit' },
  },
  justNow: 'praegu',
  yesterday: 'eile',
  today: 'täna',
  tomorrow: 'homme',
  weekStart: 1,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: {},
  timeRangeStyles: {
    yl: { start: 'D. MMMM YYYY', end: 'D. MMMM YYYY' },
    'yl-1': { start: 'D. MMMM', end: 'D. MMMM YYYY' },
    ml: { start: 'D. MMMM', end: 'D. MMMM' },
    'ml-1': { start: 'D.', end: 'D. MMMM YYYY' },
    dl: { start: 'D.', end: 'D. MMMM' },
    y: { start: 'D. MMM YYYY', end: 'D. MMM YYYY' },
    'y-1': { start: 'D. MMM', end: 'D. MMM YYYY' },
    m: { start: 'D. MMM', end: 'D. MMM' },
    'm-1': { start: 'D.', end: 'D. MMM YYYY' },
    d: { start: 'D.', end: 'D. MMM' },
    Y: { start: 'ddd, D. MMM YYYY', end: 'ddd, D. MMM YYYY' },
    'Y-1': { start: 'ddd, D. MMM', end: 'ddd, D. MMM YYYY' },
    M: { start: 'ddd, D. MMM', end: 'ddd, D. MMM' },
    D: { start: 'ddd, D. MMM', end: 'ddd, D. MMM' },
    yt: { start: 'D. MMM YYYY [kell] H.mm', end: 'D. MMM YYYY [kell] H.mm' },
    mt: { start: 'D. MMM H.mm', end: 'D. MMM H.mm' },
    dt: { start: 'D. MMM H.mm', end: 'D. MMM H.mm' },
    t: { start: 'H.mm', end: 'H.mm' },
    'yt+to': { start: 'D. MMM YYYY [kell] H.mm', end: 'D. MMM YYYY [kell] H.mm ([GMT]Z)' },
    'mt+to': { start: 'D. MMM H.mm', end: 'D. MMM H.mm ([GMT]Z)' },
    'dt+to': { start: 'D. MMM H.mm', end: 'D. MMM H.mm ([GMT]Z)' },
    't+to': { start: 'H.mm', end: 'H.mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'et';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}.`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'am' : 'AM';
    } else {
      return isLowerCase ? 'pm' : 'PM';
    }
  },
};
